import "@mantine/core/styles.css";
import "@mantine/dates/styles.css";
import "@mantine/notifications/styles.css";
import { createTheme, rem } from "@mantine/core";

export const variableResolver = (theme) => ({
  variables: {
    "--mantine-color-text": "#636363",
    "--mantine-spacing-none": "0",
  },
});

export const theme = createTheme({
  fontFamily: "Open Sans",
  black: "#636363",
  fontSizes: {
    xs: rem(10),
    sm: rem(14),
    md: rem(14),
    lg: rem(16),
    xl: rem(20),
  },
  defaultRadius: "sm",
});
